/* beautify preserve:start */
export const Role = {
    CHAIN: "CHAIN",
        BOOKING_CHAIN: "BOOKING_CHAIN",
        CHAIN_LIST: "CHAIN_LIST",
        USER_MANAGEMENT: "USER_MANAGEMENT",
    // USER_GROUP: "USER_GROUP",
    DASHBOARD: "DASHBOARD",
    MANAGE: "MANAGE",
        BOOKING_HOTEL: "BOOKING_HOTEL",
        ROOM_SALE: "ROOM_SALE",
            ROOM_SALE_MANAGEMENT: "ROOM_SALE_MANAGEMENT",
            SALE_PACKAGE_MANAGEMENT: "SALE_PACKAGE_MANAGEMENT",
        OTA_MANAGEMENT: "OTA_MANAGEMENT",
    SETTING: "SETTING",
        ACCOUNT_INFOMATION: "ACCOUNT_INFOMATION",
        PERSONAL_ACCOUNT: "PERSONAL_ACCOUNT",
        GENERAL_INFORMATION: "GENERAL_INFORMATION",
            HOTEL_AMENITY: "HOTEL_AMENITY",
            HOTEL_IMAGE: "HOTEL_IMAGE",
            NEARBY_PLACE: "NEARBY_PLACE",
        ROOM_TYPE: "ROOM_TYPE",
            // ROOM_INFORMATION: "ROOM_INFORMATION",
            // ROOM_AMENITY: "ROOM_AMENITY",
            // ROOM_IMAGE: "ROOM_IMAGE",
        HOTEL_CONFIGURATION: "HOTEL_CONFIGURATION",
            GENERAL_CONFIGURATION: "GENERAL_CONFIGURATION",
            PAYMENT_POLICY: "PAYMENT_POLICY",
            CANCELLATION_POLICY: "CANCELLATION_POLICY",
            WARNING_METHOD: "WARNING_METHOD",
        IMAGE_LIBRARY: "IMAGE_LIBRARY",
    HISTORY_LOG: "HISTORY_LOG"
};
/* beautify preserve:stop */

// SELECT * FROM `functions`
// WHERE nameVi in ("DASHBOARD_61045", "MANAGE_93748", "BOOKING_38960", "BOOKING_LIST_12573", "TRANSACTION_68254", "SALE_79628", "ROOM_AVAILABILITY_AND_RATE_32987", "RATE_PLAN_AND_PROMOTION_45069", "SETTING_65048", "ACCOUNT_INFOMATION_40139", "PERSONAL_ACCOUNT_42905", "USER_MANAGEMENT_26953", "USER_LIST_80142", "USER_GROUP_27539", "ELECTRONIC_CONTRACT_03259", "HOTEL_INFORMATION_02135", "GENERAL_INFORMATION_98172", "REGISTRATION_INFORMATION_92165", "HOTEL_AMENITY_81396", "HOTEL_IMAGE_17620", "NEARBY_PLACE_74602", "HOTEL_CHAIN_84192", "ROOM_TYPE_INFORMATION_64097", "ROOM_INFORMATION_54281", "ROOM_AMENITY_50812", "ROOM_IMAGE_87613", "HOTEL_CONFIGURATION_72465", "GENERAL_CONFIGURATION_94053", "PAYMENT_POLICY_08167", "CANCELLATION_POLICY_41895", "PAYMENT_GATEWAY_47832", "IMAGE_LIBRARY_56813", "TRAVEL_AGENT_54129", "AGENT_LIST_80513", "UNLINKED_LIST_61428", "SEND_REQUEST_54568")